import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from '../components/Navbar';
import ScrollTop from '../components/ScrollTop';
import { Aboutus, Changepassword, Contactus, Forgotpassword, HomePage, Login, PrivacyPolicy, TermofUse, GetQuotePage, Findpro, RegisterasClient, RegisterasPro } from '../pages';
import { ApplyJobForm, Footer, GetQuoteForm } from '../components';
import { AnimatePresence, motion } from 'framer-motion';
import { store } from '../shared';
import { Provider } from 'react-redux';
import Protected from './Protected';

const RouterCust = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <AppContent />
      </Provider>
    </BrowserRouter>
  );
};

const AppContent = () => {
  const [isFooterLinkClicked, setIsFooterLinkClicked] = useState(false);
  const location = useLocation();
  const [ regclient, setRegClient ] = useState(false)
  const [ jobid, setJobId ] = useState('')

  return (
    <>
      <ScrollTop />
      <Navbar {...{isFooterLinkClicked, setRegClient}}  />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route 
            index 
            path="/" 
            element={
              <Transition>
                <HomePage />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/aboutus" 
            element={
              <Transition>
                <Aboutus />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/findpro" 
            element={
              <Transition>
                <Findpro setJobId={setJobId}/>
              </Transition>
            } 
          />
          <Route 
            index 
            path="/applyproform" 
            element={
              <Protected>
                <Transition>
                  <ApplyJobForm jobid={jobid} />
                </Transition>
              </Protected>
            } 
          />
           <Route 
            index 
            path="/contactus" 
            element={
              <Transition>
                <Contactus />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/privacypolicy" 
            element={
              <Transition>
                <PrivacyPolicy />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/termofuse" 
            element={
              <Transition>
                <TermofUse />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/login" 
            element={
              <Transition>
                <Login />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/forgotpassword" 
            element={
              <Transition>
                <Forgotpassword />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/changepassword" 
            element={
              <Transition>
                <Changepassword />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/registerasclient" 
            element={
              <Transition>
                <RegisterasClient />
              </Transition>
            } 
          />
          <Route 
            index 
            path="/registeraspro" 
            element={
              <Transition>
                <RegisterasPro />
              </Transition>
            } 
          />
          <Route 
          index
          path="/getquote"
          element={
            <Protected>
              <Transition>
                <GetQuotePage />
              </Transition>
            </Protected>
          }
          />
          <Route 
          index
          path="/quoteform"
          element={
            <Transition>
              <GetQuoteForm />
            </Transition>
          }
          />

        </Routes>
      </AnimatePresence>
      <Footer />
    </>
  );
};


const Transition = ({ children }) => {
  return (
    <motion.div
      className="page-wrapper"
      initial={{ y: "10%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }} 
      exit={{ y: "-10%", opacity: 0 }}
      transition={{ duration: .5, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
};

export { RouterCust };
